module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-modal modal fade noselect",
    attrs: {
      "id": "modalAlerteAbsenceCalculee"
    }
  }, [_c('div', {
    staticClass: "modal-dialog tw-w-[756px] tw-min-w-[756px]"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.dataReady) ? _c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_vm._v("\n                                Attention, cette absence a déjà été prise en compte sur le bulletin en cours des salariés :\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "table-mode mb-3 tw-w-full tw-flex"
  }, [_c('div', {
    staticClass: "inp-table noselect d-inline-block tw-w-full"
  }, [_c('div', {
    staticClass: "tbody tw-max-h-[340px]"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.salaries), function(salarie) {
    return _c('div', {
      staticClass: "tr"
    }, [_c('div', {
      staticClass: "td cln-nom tw-w-full tw-td"
    }, [_vm._v("\n                                                Salarié N°" + _vm._s(salarie.Numero) + " - " + _vm._s(salarie.FullName) + " (Contrat N° " + _vm._s(salarie.NumeroContrat) + ")\n                                            ")])])
  })], 2)])]), _vm._v(" "), _c('div', [_vm._v("\n                                Il sera nécessaire de re-calculer ces bulletins. Souhaitez-vous vraiment continuer ?\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer mt-3 pr-0"
  }, [_c('div', {
    staticClass: "area-action"
  }, [_c('button', {
    staticClass: "inp-button-modal valid",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.valider()
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Oui")])]), _vm._v(" "), _c('button', {
    staticClass: "inp-button-modal cancel ml-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Annuler")])])])])]) : _c('div', {
    staticClass: "tw-h-28"
  }, [_c('loader')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Attention")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_c('span', {
    staticClass: "fas fa-exclamation-triangle fa-3x tw-text-red-400"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "section tw-w-full cln-nom"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb2052b0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/planningAbsences/modalAlerteAbsenceCalculee/modalAlerteAbsenceCalculee.vue.html
// module id = NpHG
// module chunks = 2